import React from 'react';

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  /** リスト項目 */
  items: (string | React.ReactNode)[];
  /** 番号付き(ordered) or 箇条書き(unordered)。デフォルト: unordered */
  variant?: 'ordered' | 'unordered';
};

/**
 * 箇条書き / 番号付きリスト共通コンポーネント
 */
const WorkflowList: React.FC<Props> = ({ items, variant = 'unordered' }) => {
  return (
    <Stack spacing={1} sx={{ pl: 1 }}>
      {items.map((item, index) => (
        <Stack key={index} direction="row" alignItems="flex-start">
          {variant === 'ordered' ? (
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 20, flexShrink: 0 }}>
              {index + 1}.
            </Typography>
          ) : (
            <FiberManualRecordIcon
              sx={{ fontSize: 6, color: 'text.disabled', mt: 0.9, flexShrink: 0 }}
            />
          )}
          {typeof item === 'string' ? (
            <Typography variant="body2" color="text.secondary">
              {item}
            </Typography>
          ) : (
            item
          )}
        </Stack>
      ))}
    </Stack>
  );
};

export default WorkflowList;
